import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';
import { FaqsComponent } from '../../../../widgets/faqs/faqs.component';
import { FaqItem } from '../../../../core/interface/faq.modal';

@Component({
  selector: 'app-problem-management-software',
  imports: [CommonModule, RouterModule, FeatureHero, FaqsComponent],
  templateUrl: './problem-management-software.html',
  styleUrl: './problem-management-software.scss',
})
export class ProblemManagementSoftware {
  faqs: FaqItem[] = [
    {
      question: 'What is Problem Management Software?',
      answer: {
        paragraphs: ['Problem management involves responding to recurring IT incidents to make sure that they are resolved and don’t return. It involves quick detection of an issue and providing a viable solution. If a solution is not available, provide a suitable workaround that will reduce the impact on the business and stop the problem from recurring.']
      }
    },
    {
      question: 'What is the problem management lifecycle?',
      answer: {
        paragraphs: ['The problem management lifecycle includes the following steps:'],
        list: {
          type: 'ul',
          items: [
            "Detection - Identifying the problem comes first, which means the underlying cause of a recurring incident.",
            "Logging - Logging the problem provides historical data with pertinent details, such as the date, time, user information, and a description of the problem.",
            "Diagnosis - Investigation of the problem by first sifting through the known error database or discovering the new cause of the problem.",
            "Workaround - Temporary fixes with a workaround can help in a pinch. But it is a temporary solution, although it helps reduce downtime and disruption.",
            "Known error record - It is a vital stage in the lifecycle as it makes resolutions faster and easier.",
            "Resolution - Once the problem has been resolved, it needs to be implemented through a change procedure to ensure the solution is working.",
            "Closure - The service desk ensures that all the details are accurate and available for future reference before updating the system by closing the problem."
          ]
        }
      }
    },
    {
      question: 'Why does an enterprise need problem management software?',
      answer: {
        paragraphs: ["Enterprises need problem management software because they help in reducing downtime and disruptions. They also enhance service availability, increase productivity, and reduce costs. Above all, problem management software helps improve user experience and customer satisfaction."]
      }
    },
    {
      question: 'What are the benefits of problem management solutions?',
      answer: {
        paragraphs: ['Some key benefits of problem management processes include:'],
        list: {
          type: 'ul',
          items: ["Preventing service disruptions", "Maintaining service quality", "Meeting SLA requirements", "Increasing productivity", "Enhanced customer satisfaction"]
        }
      }
    },
    {
      question: 'What is the main purpose of problem management software?',
      answer: {
        paragraphs: ["Problem management software identifies and eliminates the root causes of recurring incidents to prevent future service disruptions. It reduces downtime, improves service quality, and minimizes the total cost of IT operations by addressing issues at their source rather than just treating symptoms."]
      }
    },
    {
      question: 'What are the three phases of problem management?',
      answer: {
        paragraphs: ["The three phases are: Problem Identification (detecting and logging problems from incident patterns), Problem Control (investigating root causes and developing workarounds), and Error Control (implementing permanent fixes and monitoring for recurrence prevention)."]
      }
    }
  ];
}
